/**
 * De opslag van de browser, of `undefined` als die niet te benaderen is.
 *
 * Waarom een eigen functie: in een privévenster of met cookies uit gooit al de
 * BENADERING van `window.localStorage` een SecurityError — nog vóór `getItem`.
 * Wie `readX(window.localStorage)` schrijft, doet die benadering dus buiten het
 * try/catch van de lezer, en dan beschermt het niets.
 *
 * Eén plek voor alle afnemers (tekstgrootte van een vragenlijst, 'Mijn
 * afspraken' in de agenda), zodat die regel niet per scherm opnieuw ontstaat.
 *
 * @returns {Storage|undefined}
 */
const browserStorage = () => {
    try {
        return window.localStorage;
    } catch {
        return undefined;
    }
};

export default browserStorage;
